import React from 'react';
import config from '~/config';

function Safety({ t, lng, photo, isLocalePath }) {
  return (
    <div>
      <div className="container-verified">
        <div className="icon-verified">
          <img
            src={`${config.staticPrefix}/static/assets/image/download-pages/verified.svg`}
            height="24"
            alt="icon safety"
          />
        </div>
        <div className="content">{t('safety')}</div>
      </div>
      <p
        className="note-verified"
        dangerouslySetInnerHTML={{
          __html: t(config.getPrefixContent('confirmed_by_creator'), {
            creatorURL: `${config.getSiteURL()}/creator-profile/${
              photo.creator.id
            }`,
            creatorName: photo.creator.nickname,
          }),
        }}
      ></p>
      <style jsx>
        {`
          .container-verified {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 48px;
            border-radius: 4px;
            margin-top: 16px;
          }
          .icon-verified {
            background: #31d0aa;
            border-radius: 4px 0px 0px 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 48px;
            height: 100%;
          }
          .content {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            background: #ecf1f4;
            border-radius: 0px 4px 4px 0px;
            font-weight: 700;
            text-transform: uppercase;
          }
          .note-verified {
            margin-top: 4px;
          }
        `}
      </style>
      <style jsx global>
        {`
          .note-verified a {
            font-weight: 700;
          }
          .note-verified a:hover {
            opacity: 0.8;
            text-decoration: underline !important;
          }
        `}
      </style>
    </div>
  );
}

export default Safety;
